import { apiFetch } from "./client";

export interface PlatformKeyStatus {
  configured: boolean;
  masked: string | null;
  source: "database" | "env" | null;
}

export interface PlatformKeysResponse {
  braveApiKey: PlatformKeyStatus;
  githubToken: PlatformKeyStatus;
  anthropicApiKey: PlatformKeyStatus;
  tailscaleAuthKey: PlatformKeyStatus;
}

export interface SavePlatformKeysRequest {
  braveApiKey?: string;
  githubToken?: string;
  anthropicApiKey?: string;
  tailscaleAuthKey?: string;
}

export const platformKeysApi = {
  getKeys: () => apiFetch<PlatformKeysResponse>("/admin/platform-keys"),
  saveKeys: (data: SavePlatformKeysRequest) =>
    apiFetch<{ success: boolean; updated: string[] }>("/admin/platform-keys", {
      method: "POST",
      body: JSON.stringify(data),
    }),
};
